<template>
  <v-navigation-drawer
    :value="value"
    absolute
    temporary
    class="b-navigation-drawer-systems"
    @input="$emit('input', $event)"
  >
    <v-app-bar flat color="white">
      <v-app-bar-nav-icon @click="$emit('input', !value)">
        <v-icon>mdi-arrow-left</v-icon>
      </v-app-bar-nav-icon>
    </v-app-bar>

    <v-subheader>Сервисы</v-subheader>

    <BMenuFolderList
      :mini="mini"
      :selected="selected"
      :menu-list="menuListService"
      @select="$emit('select', $event)"
    />

    <v-divider class="my-6" />

    <v-subheader>Администрирование</v-subheader>

    <BMenuFolderList
      :mini="mini"
      :selected="selected"
      :menu-list="menuListAdmin"
      @select="$emit('select', $event)"
    />
  </v-navigation-drawer>
</template>

<script>
import * as MENU_FOLDERS from '@/helpers/enums/menu-folders'

import BMenuFolderList from './components/BMenuFolderList.vue'
import { rootMapper } from '@/store/modules/root'
import { analyticsClosedPermissions as AnalyticsClosedPermissions } from '@/helpers/enums/permission-models'


export default {
  name: 'BNavigationDrawerSystems',
  components: {
    BMenuFolderList,
  },
  props: {
    value: Boolean,
    selected: Object,
    mini: {
      type: Boolean,
      required: true,
    },
  },
  computed: {
    ...rootMapper.mapGetters(['profile']),
    menuListService() {
      const menu = (!this.profile.is_superuser && this.profile.is_admin
        ? [
          MENU_FOLDERS.SERVICE_LK,
        ]
        : [
          MENU_FOLDERS.SERVICE_LK,
          MENU_FOLDERS.SERVICE_ANALYTICS,
          MENU_FOLDERS.SERVICE_TESTS,
        ]
      )

      if (this.$access(AnalyticsClosedPermissions.access, false)) {
        return menu.filter((item) => item !== MENU_FOLDERS.SERVICE_ANALYTICS).map(this.handleMenu)
      }

      return menu.map(this.handleMenu)
    },
    menuListAdmin() {
      return (!this.profile.is_superuser && this.profile.is_admin
        ? [
          MENU_FOLDERS.ADMIN_LK,
        ]
        : [
          MENU_FOLDERS.ADMIN_AUTH,
          MENU_FOLDERS.ADMIN_LK,
          MENU_FOLDERS.ADMIN_COLLECTOR,
          MENU_FOLDERS.ADMIN_MARKS,
        ]
      ).map(this.handleMenu)
    },
  },
  methods: {
    handleMenu(menu) {
      if (!menu.route) return menu

      try {
        const { resolved } = this.$router.resolve(menu.route)
        const disabled = menu.disabled || resolved.matched.length === 0
        return { ...menu, disabled }
      } catch {
        return menu
      }
    },
  },
}
</script>

<style lang="scss">

.b-navigation-drawer-systems {
  position: fixed;
  top: 0;
  bottom: 0;
}
</style>
